<div class="d-flex align-items-center mb-3">
  <h2 class="me-3">Budget Overview</h2>
  <div class="ms-auto">
    <label class="me-2">Year</label>
    <select [ngModel]="year" (ngModelChange)="setYear($event)">
      <option *ngFor="let y of [year-1, year, year+1, year+2]" [value]="y">{{ y }}</option>
    </select>
  </div>
</div>

<table class="table table-sm">
  <thead>
    <tr>
      <th>Budget</th>
      <th>Employee</th>
      <th>Total</th>
      <th>YTD</th>
      <th>Status</th>
      <th colspan="12">Monthly</th>
      <th>Yuki Accounts</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let b of budgets; trackBy: trackById">
      <td>{{ b.budgetType }}</td>
      <td>{{ b.linkedEmployeeName || '-' }}</td>
      <td>{{ b.totalSpend | number:'1.0-0' }}</td>
      <td>{{ b.ytdActual | number:'1.0-0' }} / {{ b.ytdPlanned | number:'1.0-0' }}</td>
      <td>
        <span [class.text-danger]="b.overBudget" [class.text-success]="!b.overBudget">{{ b.overBudget ? 'Over' : 'Under' }}</span>
      </td>
      <td *ngFor="let _ of b.monthlyPlanned; let i = index" [title]="getMonthLabel(i)">
        <div class="bar">
          <div class="planned" [style.width.%]="b.monthlyPlanned[i] ? 100 : 0"></div>
          <div class="actual" [style.width.%]="b.monthlyPlanned[i] ? Math.min(100, (b.monthlyActual[i] / b.monthlyPlanned[i]) * 100) : 0"></div>
        </div>
      </td>
      <td>
        <span *ngFor="let acc of b.yukiAccounts; let last = last">
          <span class="badge bg-secondary me-1">{{ acc }}</span>
        </span>
      </td>
    </tr>
  </tbody>
</table>
